import type { FaireProductEntity } from "../../entity_types/product";

export const p_wwnvj7es5j: FaireProductEntity = {
  token: "p_wwnvj7es5j",
  type: "product",
  name: "I Read Banned Books Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/f6f4fc47ac9929e2be52c1ef9500df418fd2e8f3567087ad00b89299d07495f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f648a1bc3702f4df5c05ccffef5e7c6cef0fad2564685455f347c045351ebd5d.jpeg",
    "https://cdn.faire.com/fastly/02e05525fb675d3bf822ef6641c8d5cc6e4149755f240f01c1e6899125e2d59c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/6e83a2036ddc4abea870e698aef9079c81e4654426abd95eb87627b89e68486a.jpeg",
    "https://cdn.faire.com/fastly/101e6e449e4a93cf597533938d3f1ca7322e256c99e325e2d87772df7e8a954a.jpeg",
    "https://cdn.faire.com/fastly/d6873145c3f03c5e8e469122a5f51e7ce7ee04ffb0fd511255c999524dc08556.jpeg",
    "https://cdn.faire.com/fastly/d2f390e983895ff63bd42b042978e038f39759fb4be1e3c627d47e5371435a69.jpeg"
  ],
  priceDollars: 6.75,
  description: "How else are you gonna find out what the Man is afraid of??? Kick back in these comfy cushioned socks and get back to reading the stuff they don't want us reading!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:08.972Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
